import request from "@/util/request";

//产业总览-产业情况
export function getIndustrySituation() {
  return request({
    url: "/api/restful/cyzl/getIndustrySituation",
    method: "get"
  });
}

//产业总览-品种规模分析
export function getVarietyScaleAnalysis(data) {
  return request({
    url: "/api/restful/cyzl/getVarietyScaleAnalysis",
    method: "get",
    params: data
  });
}

//产业总览-产业分布
export function getIndustrialDistribution() {
  return request({
    url: "/api/restful/cyzl/getIndustrialDistribution",
    method: "get"
  });
}
